import React, { useEffect, useState } from 'react';
import './courseKit.css';

/**
 * Thin reading-progress bar for the long sales pages. Purely decorative, so it
 * is hidden from assistive tech and disabled under reduced motion.
 */
const ScrollProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return undefined;

    let frame = null;
    const update = () => {
      frame = null;
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      setPct(max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0);
    };
    const onScroll = () => {
      if (frame === null) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return <div className="ck-progress" aria-hidden="true"><span style={{ width: `${pct}%` }} /></div>;
};

export default ScrollProgress;
